import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";
import downloadFile from "../download";
import { localTime } from "@/utils/utils.js";


const _base = "rollRegister/";

// 答疑解惑 - 列表
export const rollRegisterMyPage = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "myPage", {
           data: _params,
           method: "GET",
         });
       };

// 答疑解惑 - 申请
export const rollRegisterApply = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "apply", {
    data: Qs.stringify(_params),
    method: "POST",
  });
};
// 答疑解惑 - 编辑
export const rollRegisterEdit = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "edit", {
    data: Qs.stringify(_params),
    method: "POST",
  });
};
// 答疑解惑 - 详情
export const rollRegisterView = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "view", {
    data: _params,
    method: "GET",
  });
};
// 答疑解惑 - 删除
export const rollRegisterDel = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "del", {
    data: Qs.stringify(_params),
    method: "POST",
  });
};



// WEBPACK FOOTER //
// ./src/fetch/api/rollRegister.js